import { formatVerificationDate } from "../../utils/directoryUtils";

export default function LastVerifiedDate({ date }) {
  return (
    <p className="text-xs font-bold text-neutral-500">
      Source check recorded <time dateTime={date}>{formatVerificationDate(date)}</time>
    </p>
  );
}
